import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import config from "../../../config.json";
import { msalInstance } from "../../../index";
import { searchUsers } from "../../services/graphService";
import Input from "../../common/Input";
import Select from "../../common/Select";
import TextArea from "../../common/TextArea";

function ShareModal({ showShare, onHide, onSend, shareLogs }) {
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [userOptions, setUserOptions] = useState([]);
  const [comments, setComments] = useState("");
  const [activeTab, setActiveTab] = useState("share");
  const isMountedRef = useRef(true);

  useEffect(() => {
    return () => (isMountedRef.current = false);
  }, []);

  const handleSearchUsers = async () => {
    const accessToken = await msalInstance.acquireTokenSilent({
      scopes: config.scopes,
    });
    searchUsers(accessToken, searchQuery).then((response) => {
      console.log(response);
      if (response) {
        const options = response.value.map((user) => ({
          _id: user.id,
          name: user.displayName,
          email: user.mail,
        }));
        setUserOptions(options);
      }
    });
  };

  const handleAddUser = ({ currentTarget: input }) => {
    if (input.value !== "") {
      const user = [...selectedUsers].filter(
        (obj) => obj._id === input.value
      )[0];

      if (!user) {
        let users = [...selectedUsers];
        users.push(
          [...userOptions].filter((option) => option._id === input.value)[0]
        );

        setSelectedUsers(users);
      }

      const options = [...userOptions].filter(
        (option) => option._id !== input.value
      );
      setUserOptions(options);
    }
  };

  const handleRemoveUser = (userId) => {
    const removedUser = [...selectedUsers].filter(
      (user) => user._id === userId
    );
    const options = [...userOptions];
    options.push(removedUser);
    setUserOptions(options);

    const obj = [...selectedUsers].filter((user) => user._id !== userId);
    setSelectedUsers(obj);
  };

  const handleHideModal = () => {
    onHide();
    setUserOptions([]);
    setSelectedUsers([]);
    setSearchQuery("");
    setComments("");
  };

  const handleSend = () => {
    onSend(
      selectedUsers.map((user) => user.email),
      comments
    );
    handleHideModal();
  };

  const handleActiveTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <Modal
      show={showShare}
      animation={false}
      size={activeTab === "history" ? "lg" : "md"}
    >
      <Modal.Body>
        <Tabs
          activeKey={activeTab}
          id="share-tabs"
          className="cptabs mb-4"
          transition={false}
          onSelect={handleActiveTabChange}
        >
          <Tab eventKey="share" title="Share" className="cptabs">
            {activeTab === "share" ? (
              <div className="container">
                <div className="row">
                  <div className="col">
                    <Input
                      name="SearchQuery"
                      label="Search for User(s)"
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.currentTarget.value);
                      }}
                    />
                  </div>
                  <div className="col-3">
                    <button
                      style={{ marginTop: "32px" }}
                      className="btn btn-primary"
                      onClick={handleSearchUsers}
                    >
                      Search
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <Select
                      name="Users"
                      label="Select User(s)"
                      options={userOptions}
                      onChange={handleAddUser}
                    />
                  </div>
                </div>
                {selectedUsers.length > 0 && (
                  <div className="row border-bottom">
                    <div className="col border-end">Name</div>
                    <div className="col">Email</div>
                  </div>
                )}
                {selectedUsers.map((user) => (
                  <div key={user._id} className="row border-bottom">
                    <div className="col border-end">
                      <i
                        className="fas fa-times text-danger me-2 fa-lg"
                        onClick={() => {
                          handleRemoveUser(user._id);
                        }}
                      ></i>
                      {user.name}
                    </div>
                    <div className="col">{user.email}</div>
                  </div>
                ))}
                <div className="row mt-3">
                  <div className="col">
                    <TextArea
                      name="comment"
                      label="Comments"
                      value={comments}
                      onChange={(e) => {
                        setComments(e.currentTarget.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            ) : null}
          </Tab>
          <Tab eventKey="history" title="History" className="cptabs">
            {activeTab === "history" ? (
              shareLogs.length === 0 ? (
                "No Share History for this Submission."
              ) : (
                <div className="container border-top border-start">
                  <div className="row border-bottom">
                    <div className="col border-end py-2">Sender</div>
                    <div className="col border-end py-2">Recipient(s)</div>
                    <div className="col border-end py-2">Date</div>
                  </div>
                  {shareLogs.map((value) => {
                    return (
                      <div className="row border-bottom" key={value.RelatedId}>
                        <div className="col border-end py-2">
                          {value.ObjectJSON.sharedBy}
                        </div>
                        <div className="col border-end py-2">
                          {value.ObjectJSON.sharedTo}
                        </div>
                        <div className="col border-end py-2">
                          {moment
                            .utc(value.ObjectJSON.logDateTime)
                            .local()
                            .format("lll")}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )
            ) : null}
          </Tab>
        </Tabs>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-danger" onClick={handleHideModal}>
          Cancel
        </button>
        {activeTab !== "history" ? (
          <button className="btn btn-primary" onClick={handleSend}>
            Share
          </button>
        ) : null}
      </Modal.Footer>
    </Modal>
  );
}

export default ShareModal;
